module.exports = __webpack_public_path__ + "assets/RestaurantMarker-old-43a351.svg";